<template>
  <div>
    <v-select
      id="solution-select"
      v-model="solucaoId"
      item-text="nome"
      item-value="solucaoId"
      :items="solutions"
      :label="`${isAT ? 'Iniciativas' : isGov ? 'Fases' : 'Solução'}`"
      placeholder="Solução"
      clearable
      :multiple="multiple"
      @change="$emit('changeSolution', solucaoId)"
      :return-object="returnObject"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay"
          >{{ diminuirValue(item.nome) }} &nbsp;</span
        >
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ solucaoId.length - maxDisplay }} soluções)</span
        >
      </template>
      <template slot="no-data">
        Nenhuma {{ isAT ? "Iniciativa" : isGov ? "Fase" : "Solução" }} retornada
      </template>
    </v-select>
  </div>
</template>

<script>
import { solutionAPI } from "@/modules/solution";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppSolutionCombobox",
  props: [
    "filter",
    "multiple",
    "filterSolutions",
    "solutionIds",
    "returnObject",
  ],
  data() {
    return {
      solutions: [],
      solucaoId: null,
      maxDisplay: 1,
    };
  },
  methods: {
    loadSolutions() {
      solutionAPI.list({}).then((res) => {
        this.solutions = res.data;
      });
    },
    diminuirValue(item) {
      if (item && item.length > 15) {
        return item.substring(0, 15) + "...";
      }

      return item;
    },
  },
  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  watch: {
    filterSolutions: {
      handler(val, oldVal) {
        if (val && val.length) {
          this.solutions = val;
        }
      },
      deep: true,
    },
    solutionIds: {
      handler(val) {
        this.solucaoId = val;
        this.$forceUpdate();
      },
      deep: true,
    },
    filter: {
      handler(val, oldVal) {
        this.solucaoId = val.solucaoId;
        if (val.solutions) this.solutions = val.solutions;
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.filter.solutions) {
      this.loadSolutions();
    } else {
      this.solutions = this.filter.solutions;
    }
    this.solucaoId = this.solutionIds;
  },
};
</script>
